import { render } from "./ModalVotacionFiebreDeBaile.vue?vue&type=template&id=6401fc7c&scoped=true"
import script from "./ModalVotacionFiebreDeBaile.vue?vue&type=script&lang=js"
export * from "./ModalVotacionFiebreDeBaile.vue?vue&type=script&lang=js"

import "./ModalVotacionFiebreDeBaile.vue?vue&type=style&index=0&id=6401fc7c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6401fc7c"]])

export default __exports__